import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/talk-more-icon.png'
import _imports_1 from '@/assets/img/no-image.png'
import _imports_2 from '@/assets/img/pickup-button-vector.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-352329ba")

_pushScopeId("data-v-352329ba")
const _hoisted_1 = { class: "talk-now" }
const _hoisted_2 = { class: "talk-headline-box" }
const _hoisted_3 = /*#__PURE__*/_createVNode("h1", { class: "txt txt-headline talk-headline" }, "今すぐお話しする", -1)
const _hoisted_4 = {
  key: 0,
  class: "talk-more-box"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "talk-more-text txt" }, "もっと見る", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("img", {
  class: "talk-more-icon",
  src: _imports_0
}, null, -1)
const _hoisted_7 = { class: "talk-now-nothing-container" }
const _hoisted_8 = {
  key: 0,
  class: "txt talk-now-nothing-box"
}
const _hoisted_9 = { class: "talk-now-talent" }
const _hoisted_10 = {
  key: 0,
  class: "talk-future-img",
  src: _imports_1
}
const _hoisted_11 = { class: "held-live-box" }
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "held-live-text txt txt-wt txt-detail" }, "開催中", -1)
const _hoisted_13 = { class: "talent-name txt txt-small" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "talk-now-circle" }, [
  /*#__PURE__*/_createVNode("img", {
    class: "talk-now-circle-vector",
    src: _imports_2
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_Imgix = _resolveComponent("Imgix")
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")
  const _component_Swiper = _resolveComponent("Swiper")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      (_ctx.nowTalents.length !== 0)
        ? (_openBlock(), _createBlock("div", _hoisted_4, [
            _createVNode(_component_router_link, {
              class: "talk-more-box",
              to: { name: 'TalkNowTalentsScreen' }
            }, {
              default: _withId(() => [
                _hoisted_5,
                _hoisted_6
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_7, [
      (_ctx.nowTalents.length === 0)
        ? (_openBlock(), _createBlock("p", _hoisted_8, "通話のスケジュールがここに表示されます"))
        : _createCommentVNode("", true)
    ]),
    _createVNode("div", _hoisted_9, [
      (_ctx.nowTalents !== [])
        ? (_openBlock(), _createBlock(_component_Swiper, {
            key: 0,
            autoplay: _ctx.state.autoplayOptions,
            breakpoints: _ctx.state.breakpointOptions,
            "slides-per-view": 2.2,
            "space-between": 12
          }, {
            default: _withId(() => [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nowTalents, (nowTalent, index) => {
                return (_openBlock(), _createBlock(_component_SwiperSlide, {
                  onClick: ($event: any) => (_ctx.openTalent(nowTalent.talentID))
                }, {
                  default: _withId(() => [
                    (nowTalent.mainImage === '')
                      ? (_openBlock(), _createBlock("img", _hoisted_10))
                      : (_openBlock(), _createBlock(_component_Imgix, {
                          key: 1,
                          class: "talk-now-img",
                          imageUrl: nowTalent.mainImage,
                          imageSize: _ctx.imageSize
                        }, null, 8, ["imageUrl", "imageSize"])),
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "held-live-icon",
                        icon: "phone"
                      }),
                      _hoisted_12
                    ]),
                    _createVNode("div", _hoisted_13, _toDisplayString(nowTalent.displayName), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 256)),
              _hoisted_14
            ]),
            _: 1
          }, 8, ["autoplay", "breakpoints", "slides-per-view"]))
        : _createCommentVNode("", true)
    ])
  ]))
})